import { InputGroup, Intent } from '@blueprintjs/core';
import * as React from 'react';
import { Field } from 'react-final-form';

import useClientTranslations from '../../../../hooks/useClientTranslations';
import { TractableFormGroup } from './Shared';

export const required =
	(field: string, t: any, isRequired = true) =>
	(value: any) =>
		value || !isRequired ? undefined : t(`{{field}} is required`, { field });

const PolicyholderLastname: React.FC<{ isRequired?: boolean }> = ({ isRequired = true }) => {
	const { t } = useClientTranslations();

	return (
		<Field name="policyholderLastname" validate={required(t('Policyholder Lastname'), t, isRequired)}>
			{({ input, meta }) => (
				<TractableFormGroup
					label={t('Policyholder Lastname')}
					inline
					intent={Intent.DANGER}
					helperText={
						meta.invalid && meta.touched && (t(meta.error) || (!meta.dirtySinceLastSubmit && t(meta.submitError)))
					}
				>
					<InputGroup {...input} placeholder="" />
				</TractableFormGroup>
			)}
		</Field>
	);
};

export { PolicyholderLastname };
